import { defineStore } from 'pinia';
import { router } from '@/router';
import { fetchWrapper } from '@/utils/helpers/fetch-wrapper';

const baseUrl = `${import.meta.env.VITE_API_BASE_URL || '/api'}/lettaga-adm/auth-adm`;

export const useAuthStore = defineStore('auth',{

    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        // @ts-ignore
        user: JSON.parse(localStorage.getItem('admin-user') || 'null'),
        returnUrl: null
    }),
    actions: {
        async login(username: string, password: string) {
            const response = await fetchWrapper.post(`${baseUrl}/login`, { userId: username, password });

            if (response.success && response.user) {
                // update pinia state
                this.user = response.user;
                // store user details in local storage
                localStorage.setItem('admin-user', JSON.stringify(response.user));
                // redirect to previous url or default to home page
                router.push(this.returnUrl || '/main/dashboards/general');
            } else {
                throw new Error(response.message || '로그인에 실패했습니다');
            }
        },
        async register(email: string, userName: string, password: string, phoneNo?: string, userType?: string) {
            const response = await fetchWrapper.post(`${baseUrl}/register`, {
                email,
                userName,
                password,
                phoneNo,
                userType
            });

            if (response.success) {
                return response;
            } else {
                throw new Error(response.message || '회원가입에 실패했습니다');
            }
        },
        async logout() {
            try {
                await fetchWrapper.post(`${baseUrl}/logout`, {});
            } catch (e) {
                // 로그아웃 API 실패해도 로컬 상태는 초기화
            }
            this.user = null;
            localStorage.removeItem('admin-user');
            router.push('/auth/login');
        }
    }
});

